<template>
	<div class="goodcase">
		<div class="container">
			<div class="comnewlist" v-for="item in data">
				<div class="left">
					<img :src="item.pic"/>
				</div>
				<div class="center">
					<h2>{{item.title}}</h2>
					<p>{{item.summary}}</p>
				</div>
				<!-- <div class="right">
					<h3>{{item.addtime}}</h3>
					<p>查看详情</p>
				</div> -->
			</div>
		</div>
	</div>
	
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:"公司新闻",
				data:[]
			}
		},
		methods:{
			getList(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.projectGetListApi,
					data: {}
				})
				.then((res) => {
					this.data = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			},
			gotoDetail(id){
				this.$router.push({
				          	path: '/ProjectDetail',
				          	query: {
				          		id:	 id,         
				          	}
				      	})
			},
		},
		created(){
			this.getList();
		}
	}
</script>

<style lang="less" scoped="scoped">
.goodcase{
	margin-top: 60px;
	.comnewlist{
		width: 100%;
		height: 200px;
		margin-bottom: 30px;
		background: #f7f7f7;
		cursor:pointer;
		.left{
			display: inline-block;
			width: 24%;
			height: 100%;
			float: left;
			
			img{
				width: 100%;
				height: 100%;
				padding:20px
			}
		}
		.center{
			display: inline-block;
			width: 57%;
			height: 100%;
			float: left;
			padding-left: 30px;
			padding-top: 40px;
			h2{
				font-size: 22px;
				font-weight: 600px;
				margin-bottom: 30px;
			}
			p{
				width: 100%;
				height: 40px;
				overflow: hidden;
				padding: 7px;
				font-size: 15px;
			}
		}
		.right{
			display: inline-block;
			width: 18%;
			height: 100%;
			float: right;
			padding-top: 40px;
			padding-left: 30px;
			h3{
				color: #999;
				margin-bottom: 30px;
				font-size: 20px;
			}
			p{
				width: 90px;
				height: 35px;
				border: 1px solid #000;
				text-align: center;
				line-height: 35px;
			}
		}
	}
	.comnewlist:hover{
		/*border: 5px solid orangered;*/
		box-shadow:4px 4px 10px #ddd;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/ProjectCase/Pcom/Goodcase.vue